import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LandingButton } from './LandingButton';

export const PlansPreview: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="px-4 md:px-8">
      <div className="relative mx-auto max-w-[1180px] overflow-hidden rounded-3xl bg-[rgb(244,238,226)] px-7 py-12 md:px-14 md:py-20">
        <div className="relative z-10 mx-auto flex max-w-md flex-col items-center text-center md:mx-0 md:items-start md:text-left">
          <h2 className="font-['Inter'] text-[40px] sm:text-[clamp(2.25rem,54px,64px)] font-light leading-[1.02] text-[#23262C] md:whitespace-nowrap">
            Check Out Our Plans
          </h2>
          <LandingButton
            className="mt-8"
            showArrow={false}
            onClick={() => navigate('/landing/plans')}
          >
            View them here
          </LandingButton>
        </div>

        {/* Peeking plan cards (mock from PSD) */}
        {/* <img
          src="/images/landing/seeplans.png"
          alt=""
          className="pointer-events-none absolute -right-4 top-0 h-full hidden w-[52%] max-w-[620px] select-none lg:block"
        /> */}
        <div style={{
          backgroundImage: 'url(/images/landing/seeplans.png)',
          backgroundSize: "cover",
          backgroundPosition: 'left',
          backgroundRepeat: 'no-repeat',
          width: '52%',
          height: '100%',
          position: 'absolute',
          right: '-4rem',
          top: '0',
        }} className='hidden md:block' />
      </div>
    </section>
  );
};
